import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { ColorTokens } from '@vds-tokens/color';
import { Body } from '@vds-core/typography';
import { TrailingTooltip } from '@vds-core/tooltips';
var propTypes = {
  /**
   * If provided, will render the ListGroupItemSubtitle when surface is light or dark.
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * Determines whether mobile, or desktop fontstacks are used.
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * Content for subtitle
   */
  children: PropTypes.node,

  /**
   * Config object for tooltip option
   * @note Can be used with all actionElement options specified in ListGroupItem
   */
  tooltip: PropTypes.shape({
    renderAnchorElement: PropTypes.func,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    containerId: PropTypes.string,
    ariaLabel: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    closeButtonText: PropTypes.string
  })
};
var defaultProps = {
  surface: 'light',
  viewport: 'desktop'
};

var ListGroupItemSubtitle = function ListGroupItemSubtitle(props) {
  var surface = props.surface,
      viewport = props.viewport,
      children = props.children,
      tooltip = props.tooltip,
      tabIndex = props.tabIndex;
  var hasTooltip = tooltip && (tooltip.title || tooltip.children);
  var subtitleColor = ColorTokens.elements.secondary["on".concat(surface)].value;
  var isMobile = viewport === 'mobile';

  var _renderSubtitleAlone = function _renderSubtitleAlone() {
    return /*#__PURE__*/React.createElement(Body, {
      color: subtitleColor,
      size: isMobile ? 'small' : 'large',
      viewport: viewport
    }, children);
  };

  var _renderTrailingTooltip = function _renderTrailingTooltip() {
    return /*#__PURE__*/React.createElement("span", {
      onClick: function onClick(e) {
        if (e) {
          e.stopPropagation();
        }
      }
    }, /*#__PURE__*/React.createElement(TrailingTooltip, _extends({
      tabIndex: 0
    }, tooltip, {
      typographyType: "body",
      typographySize: isMobile ? 'small' : 'large',
      typographyColor: subtitleColor,
      viewport: viewport,
      iconFillColor: "secondary",
      surface: surface,
      tooltipTitle: !!tooltip.title ? tooltip.title : undefined,
      tooltipContent: !!tooltip.children ? tooltip.children : undefined,
      tooltipCloseButtonText: !!tooltip.closeButtonText ? tooltip.closeButtonText : undefined,
      tooltipSize: isMobile ? 'small' : 'medium'
    }), children));
  };

  return hasTooltip ? _renderTrailingTooltip() : _renderSubtitleAlone();
};

ListGroupItemSubtitle.propTypes = propTypes;
ListGroupItemSubtitle.defaultProps = defaultProps;
ListGroupItemSubtitle.displayName = 'ListGroupItemSubtitle';
export default ListGroupItemSubtitle;